import {Component} from '@angular/core';

@Component({
    styleUrls: ['./discard-changes-prompt.component.css'],
    templateUrl: './discard-changes-prompt.component.html'
})
export class DiscardChangesPromptComponent {
}